import {atom} from 'jotai';

export const unfilledRegistrationFieldRefAtom = atom<React.RefObject<HTMLInputElement> | null>(null);